import { WorkerStage } from "@clipboard-health/contract-worker-app-bff";
import { PageHeaderWrapper, Text } from "@clipboard-health/ui-components";
import { getTheme } from "@clipboard-health/ui-theme";
import { Stack, ThemeProvider } from "@mui/material";
import { PullToRefresh } from "@src/appV2/lib/PullToRefresh/PullToRefresh";
import { openZendeskMessaging } from "@src/appV2/lib/ZendeskMessaging/openZendeskMessaging";

import { PageWrapper } from "../../components/PageWrapper";
import { SelectableBox } from "../../components/SelectableBox";
import { useIsJobsEnabled } from "../../PlacementCandidate/useIsJobsEnabled";
import { logInviteCalloutViewed } from "../../Shift/Invite/logInviteCalloutViewed";
import { PageContent } from "../../WorkerShifts/components/PageContent";
import { SHIFT_INVITES_FULL_PATH } from "../../WorkerShifts/path";
import { ListViewBanners } from "../ListView/Banners";
import { BrowseJobsCta } from "../Restricted/BrowseJobsCta";
import { Info } from "./Info";

interface InviteRequiredPageContentProps {
  clipboardScore: number;
  shiftInviteCount: number;
  visitInviteCount: number;
  workerStage: WorkerStage;
  onRefresh: () => Promise<void>;
}

export function InviteRequiredPageContent(props: InviteRequiredPageContentProps) {
  const { clipboardScore, shiftInviteCount, visitInviteCount, workerStage, onRefresh } = props;

  const totalInviteCount = shiftInviteCount + visitInviteCount;
  const isJobsEnabled = useIsJobsEnabled();

  return (
    <ThemeProvider theme={getTheme()}>
      <PageWrapper variant="tertiary">
        <PullToRefresh onRefresh={onRefresh} />

        <PageContent sx={(theme) => ({ paddingTop: theme.spacing(4) })}>
          <PageHeaderWrapper variant="tertiary" sx={{ mx: -5 }}>
            <ListViewBanners showClipboardScoreBanner={false} />
          </PageHeaderWrapper>
          <Stack flex={1} spacing={5} mt={8}>
            <Text variant="h3" textAlign="center">
              Your account is now{" "}
              <Text noWrap inline variant="h3">
                invite-required
              </Text>
            </Text>
            <Info clipboardScore={clipboardScore} />
            {isJobsEnabled && <BrowseJobsCta />}
            <SelectableBox
              withCallToActionIcon
              startIconType="email"
              href={SHIFT_INVITES_FULL_PATH}
              onClickCapture={() => {
                logInviteCalloutViewed({
                  source: "inviteRequired",
                  workerStage,
                  shiftInviteCount,
                  visitInviteCount,
                });
              }}
            >
              View invites ({totalInviteCount})
            </SelectableBox>
            <SelectableBox
              withCallToActionIcon
              startIconType="text-bubble"
              sx={{ textAlign: "left" }}
              onClickCapture={async () => {
                await openZendeskMessaging();
              }}
            >
              Chat with support
            </SelectableBox>
          </Stack>
        </PageContent>
      </PageWrapper>
    </ThemeProvider>
  );
}
